if (!themeBase.stickySidebar) {
    class StickySidebar {
        constructor() {
            this.settings = {
                offset: 40,
                minHeightDiff: 100
            };

            this.current = {
                scroll: 0
            };

            this.load();
        }

        load() {
            this.stickyHeader = document.querySelector('sticky-header'),

            this.getSidebars();
            this.update();
            window.addEventListener('scroll', this.update.bind(this));
            window.addEventListener('resize', this.update.bind(this));
            window.addEventListener('FacetsOpenInputChanged', this.update.bind(this));
            window.addEventListener('MutationObserverLoaded', this.update.bind(this));
        }

        reload() {
            this.getSidebars();
            this.update();
        }

        getSidebars() {
            const sidebars = document.querySelectorAll('.js-sticky-sidebar');
            this.sidebars = [];

            [...sidebars].forEach(element => {
                const sidebarBody = element.querySelector('[data-js-sticky-sidebar-body]');

                this.sidebars.push({
                    element: element,
                    parent: element.parentNode,
                    body: sidebarBody,
                    state: null,
                    disableOffsets: sidebarBody.hasAttribute('data-js-disable-offsets') ? true : false
                });
            });
        }

        resetSidebar(sidebar) {
            sidebar.element.classList.remove('sidebar-fixed-bottom', 'sidebar-static-bottom', 'sidebar-fixed-top', 'sidebar-offset-top');
            sidebar.body.removeAttribute('style');
        }

        startAction(state, sidebar, callback) {
            if(sidebar.state !== state) {
                callback();
                sidebar.state = state;
            }
        }
        
        update(action, scroll) {
            if(!themeBase.isDesktop) {
                return;
            } else if(action === 'listener-enable') {
                this.fixed = true;
            } else if(action === 'listener-disable') {
                this.fixed = null;
                return;
            }
            
            scroll = scroll ? scroll : window.scrollY;
            const _ = this;
            let headerOffsetTop = 0;
            let footbarOffsetBottom = false && this.productFootbar ? Math.ceil(this.productFootbar.height) : 0;

            this.sidebars.forEach(function (sidebar) {
                const parentBounds = sidebar.parent.getBoundingClientRect();
                const bodyBounds = sidebar.body.getBoundingClientRect();
                let offsetTop = null;

                if((bodyBounds.height + _.settings.minHeightDiff >= parentBounds.height) || !themeBase.isDesktop) {
                    //off
                    _.startAction(1, sidebar, function () {
                        _.resetSidebar(sidebar);
                    });

                    sidebar.parentBounds = parentBounds;
                    sidebar.bodyBounds = bodyBounds;

                    return;
                }

                if(sidebar.disableOffsets) {
                    headerOffsetTop = 0;
                    footbarOffsetBottom = 0;
                }

                if(action === 'listener-enable') {
                    sidebar.element.classList.add('sidebar-fixed-top');
                    sidebar.element.classList.remove('sidebar-offset-top', 'sidebar-fixed-bottom', 'sidebar-static-bottom');
                    sidebar.body.style.width = sidebar.element.offsetWidth / 10 + 'rem';
                    sidebar.body.style.top = bodyBounds.top / 10 + 'rem';
                    sidebar.body.style.bottom = '';
                    sidebar.body.style.marginTop = '';
                    sidebar.state = null;
                    sidebar.parentBounds = parentBounds;
                    sidebar.bodyBounds = bodyBounds;

                    return;
                } else if(action === 'listener-process') {
                    if(bodyBounds.height >= parentBounds.height) {
                        _.startAction(1, sidebar, function () {
                            _.resetSidebar(sidebar);
                        });
                    } else if(parentBounds.height > sidebar.parentBounds.height && parentBounds.bottom > _.settings.offset + headerOffsetTop && bodyBounds.top < _.settings.offset + headerOffsetTop) {
                        //parent larger
                        if(parentBounds.bottom < themeBase.windowHeight - _.settings.offset - footbarOffsetBottom) {
                            offsetTop = parentBounds.height - bodyBounds.height;
                        } else if(bodyBounds.top > parentBounds.top && sidebar.parentBounds.bottom < themeBase.windowHeight) {
                            offsetTop = parentBounds.height - bodyBounds.height - (parentBounds.bottom - themeBase.windowHeight) - _.settings.offset - footbarOffsetBottom;
                        }

                        if(offsetTop && offsetTop > 0) {
                            sidebar.element.classList.remove('sidebar-fixed-top', 'sidebar-static-bottom')
                            sidebar.element.classList.add('sidebar-offset-top');
                            sidebar.body.style.width = '';
                            sidebar.body.style.top = '';
                            sidebar.body.style.marginTop = offsetTop / 10 + 'rem';
                        }
                    } else if(parentBounds.height < sidebar.parentBounds.height) {
                        //parent smaller
                        if(sidebar.element.classList.contains('sidebar-fixed-top')) {
                            if(Math.ceil(parentBounds.bottom) < Math.floor(bodyBounds.bottom)) {
                                sidebar.element.classList.remove('sidebar-fixed-top', 'sidebar-offset-top')
                                sidebar.element.classList.add('sidebar-static-bottom');
                                sidebar.body.removeAttribute('style');
                            }
                        }
                    } else if(bodyBounds.height !== sidebar.bodyBounds.height) {
                        //body smaller
                        if(parentBounds.bottom < themeBase.windowHeight - _.settings.offset - footbarOffsetBottom) {
                            if(bodyBounds.top !== parentBounds.top) {
                                sidebar.body.style.top = ((bodyBounds.height - themeBase.windowHeight) * -1 - (themeBase.windowHeight - parentBounds.bottom)) / 10 + 'rem';
                            }
                        } else if(bodyBounds.bottom < themeBase.windowHeight) {
                            if(bodyBounds.height > themeBase.windowHeight - _.settings.offset * 2 - headerOffsetTop - footbarOffsetBottom) {
                                sidebar.body.style.top = ((bodyBounds.height -  themeBase.windowHeight) * -1 - _.settings.offset - footbarOffsetBottom) / 10 + 'rem';
                            } else if(parentBounds.top < _.settings.offset + headerOffsetTop) {
                                sidebar.body.style.top = (_.settings.offset + headerOffsetTop) / 10 + 'rem';
                            }
                        } else if(bodyBounds.bottom > parentBounds.bottom) {
                            sidebar.body.style.top = ((bodyBounds.height - themeBase.windowHeight) * -1 - (themeBase.windowHeight - parentBounds.bottom)) / 10 + 'rem';
                        }
                    }

                    sidebar.bodyBounds = bodyBounds;
                    sidebar.parentBounds = parentBounds;

                    return;
                }

                if(_.fixed) {
                    return;
                }

                if(bodyBounds.height > themeBase.windowHeight - _.settings.offset * 2 - headerOffsetTop - footbarOffsetBottom) {
                    //longer
                    if(scroll > _.current.scroll) {
                        //down
                        if(Math.floor(bodyBounds.bottom) > Math.ceil(themeBase.windowHeight - _.settings.offset - footbarOffsetBottom)) {
                            //body bottom below window bottom
                            _.startAction(2, sidebar, function () {
                                if(parentBounds.top < _.settings.offset + headerOffsetTop && !sidebar.element.classList.contains('sidebar-offset-top')) {
                                    offsetTop = parentBounds.top - bodyBounds.top;
                                    sidebar.element.classList.add('sidebar-offset-top');
                                }

                                sidebar.element.classList.remove('sidebar-fixed-bottom', 'sidebar-static-bottom', 'sidebar-fixed-top');
                                sidebar.body.style.width = '';
                                sidebar.body.style.top = '';
                                sidebar.body.style.bottom = '';

                                if(offsetTop) {
                                    sidebar.body.style.marginTop = offsetTop / 10 * -1 + 'rem';
                                    offsetTop = null;
                                }
                            });
                        } else {
                            //body bottom above window bottom
                            if(Math.floor(parentBounds.bottom) > Math.ceil(themeBase.windowHeight - _.settings.offset - footbarOffsetBottom)) {
                                //parent bottom below window bottom
                                _.startAction(3, sidebar, function () {
                                    sidebar.body.style.width = sidebar.element.offsetWidth / 10 + 'rem';
                                    sidebar.body.style.top = '';
                                    sidebar.body.style.bottom = (_.settings.offset + footbarOffsetBottom) / 10 + 'rem';
                                    sidebar.body.style.marginTop = '';
                                    sidebar.element.classList.remove('sidebar-static-bottom', 'sidebar-fixed-top', 'sidebar-offset-top')
                                    sidebar.element.classList.add('sidebar-fixed-bottom');
                                });
                            } else {
                                //parent bottom above window bottom
                                _.startAction(4, sidebar, function () {
                                    sidebar.element.classList.remove('sidebar-fixed-bottom', 'sidebar-fixed-top', 'sidebar-offset-top')
                                    sidebar.element.classList.add('sidebar-static-bottom');
                                    sidebar.body.removeAttribute('style');
                                });
                            }
                        }
                    } else if(scroll < _.current.scroll) {
                        //up
                        if(bodyBounds.top < _.settings.offset + headerOffsetTop) {
                            //body top above window top
                            _.startAction(5, sidebar, function () {
                                if(parentBounds.top < _.settings.offset + headerOffsetTop && !sidebar.element.classList.contains('sidebar-offset-top')) {
                                    offsetTop = parentBounds.top - bodyBounds.top;
                                    sidebar.element.classList.add('sidebar-offset-top');
                                }

                                sidebar.element.classList.remove('sidebar-fixed-top', 'sidebar-fixed-bottom');
                                sidebar.body.style.width = '';
                                sidebar.body.style.top = '';
                                sidebar.body.style.bottom = '';

                                if(offsetTop) {
                                    sidebar.body.style.marginTop = offsetTop / 10 * -1 + 'rem';
                                    offsetTop = null;
                                }
                            });
                        } else {
                            //body top below window top
                            if(parentBounds.top < _.settings.offset + headerOffsetTop) {
                                //parent top below window top
                                _.startAction(6, sidebar, function () {
                                    sidebar.body.style.width = sidebar.element.offsetWidth / 10 + 'rem';
                                    sidebar.body.style.top = (_.settings.offset + headerOffsetTop) / 10 + 'rem';
                                    sidebar.body.style.bottom = '';
                                    sidebar.body.style.marginTop = '';
                                    sidebar.element.classList.remove('sidebar-offset-top', 'sidebar-fixed-bottom', 'sidebar-static-bottom')
                                    sidebar.element.classList.add('sidebar-fixed-top');
                                });
                            } else {
                                //this bottom above window bottom
                                _.startAction(1, sidebar, function () {
                                    _.resetSidebar(sidebar);
                                });
                            }
                        }
                    }
                } else {
                    //shorter
                    if(parentBounds.top < _.settings.offset + headerOffsetTop) {
                        //body top above window top
                        if(bodyBounds.height < parentBounds.bottom - _.settings.offset - headerOffsetTop) {
                            //body bottom below parent bottom
                            _.startAction(7, sidebar, function () {
                                sidebar.body.style.width = sidebar.element.offsetWidth / 10 + 'rem';
                                sidebar.body.style.top = (_.settings.offset + headerOffsetTop) / 10 + 'rem';
                                sidebar.body.style.bottom = '';
                                sidebar.body.style.marginTop = '';
                                sidebar.element.classList.remove('sidebar-static-bottom', 'sidebar-fixed-bottom', 'sidebar-offset-top')
                                sidebar.element.classList.add('sidebar-fixed-top');
                            });
                        } else {
                            //body bottom above parent bottom
                            _.startAction(8, sidebar, function () {
                                sidebar.element.classList.remove('sidebar-fixed-top', 'sidebar-offset-top', 'sidebar-fixed-bottom')
                                sidebar.element.classList.add('sidebar-static-bottom');
                                sidebar.body.removeAttribute('style');
                            });
                        }
                    } else {
                        //body top below window top
                        _.startAction(1, sidebar, function () {
                            _.resetSidebar(sidebar);
                        });
                    }
                }
            });

            this.current.scroll = scroll;
        }
    }

    themeBase.stickySidebar = new StickySidebar;
}